import React from "react";
import { dispositionClass } from "../lib/dispositions";

export const DispositionTag = ({ value, className = "" }) => {
  if (!value) {
    return (
      <span
        data-testid="disposition-tag-empty"
        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-white/5 text-white/40 border border-white/10"
      >
        — unset
      </span>
    );
  }
  return (
    <span
      data-testid={`disposition-tag-${value.replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${dispositionClass(
        value
      )} ${className}`}
    >
      {value}
    </span>
  );
};

export default DispositionTag;
